import { render } from "./MultipleSelectOptions.vue?vue&type=template&id=b44ecf52&scoped=true"
import script from "./MultipleSelectOptions.vue?vue&type=script&lang=ts"
export * from "./MultipleSelectOptions.vue?vue&type=script&lang=ts"

import "./MultipleSelectOptions.vue?vue&type=style&index=0&id=b44ecf52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b44ecf52"

export default script